import { $mount } from '../../../js/dom-lifecycle';

const modal = document.getElementById('confirm-modal')
const modalTitle = modal.querySelector('h4');
const modalMessage = modal.querySelector('p');
const modalOkBtn = modal.querySelector('#confirm-modal-ok-button');
const modalOkBtnText = modalOkBtn.querySelector('span');
const modalCancelBtn = modal.querySelector('#confirm-modal-cancel-button');
const modalCancelBtnText = modalCancelBtn.querySelector('span');

window.confirm = function(message = modalMessage.dataset.default, {
    title = null,
    btnType = 'primary',
    okText = modalOkBtnText.dataset.default,
    cancelText = modalCancelBtnText.dataset.default
} = {}) {
    message = message || modalMessage.dataset.default;
    modalMessage.innerText = message;
    modalTitle.innerText = title;
    modalOkBtn.setAttribute('class', `btn btn-${btnType}`);
    modalOkBtnText.innerText = okText;
    modalCancelBtnText.innerText = cancelText;
    bootstrap.Modal.getOrCreateInstance(modal).show();
    return new Promise((resolve, reject) => {
        modalOkBtn.addEventListener('click', () => resolve());
        modalCancelBtn.addEventListener('click', () => reject());
    });
}

$mount('[data-confirm]').on('click', e => {
    const el = e.currentTarget;
    if (el.dataset.confirmModalConfirmed) return true;
    e.preventDefault();
    const data = el.dataset;
    window.confirm(data.confirmMessage || data.confirm, {
        title: data.confirmTitle,
        btnType: data.confirmBtnType,
        okText: data.confirmOkText,
        cancelText: data.confirmCancelText,
    }).then(() => {
        el.dataset.confirmModalConfirmed = true;
        el.click();
        delete el.dataset.confirmModalConfirmed;
        bootstrap.Modal.getOrCreateInstance(modal).hide();
    }).catch(() => {
        bootstrap.Modal.getOrCreateInstance(modal).hide();
    });
    return false;
});
